import TumengValuation from './src/index.vue'

TumengValuation.install = function(Vue) {
  Vue.component(TumengValuation.name, TumengValuation)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengValuation)
}

export default TumengValuation
